export default __webpack_public_path__ + "static/media/onei.88a5b62e.png";